const container = "_container_1qhtc_10";
const input = "_input_1qhtc_18";
const ui = "_ui_1qhtc_19";
const styles = {
  container,
  input,
  ui
};
export {
  container,
  styles as default,
  input,
  ui
};
//# sourceMappingURL=Radio.module.css.js.map
